<template>
  <CustomModal
    v-model:visible="modalVisible"
    :title="title"
    width="400px"
    :source="`${source}_instructions_modal`"
    @close="handleCancel"
  >
    <div class="flex flex-col gap-4">
      <span class="text_color font-normal text-sm leading-[18px]">
        {{ description }}
      </span>
      <a-textarea
        class="textarea_large"
        v-model:value="instructions"
        :rows="6"
        :placeholder="placeholder"
        ref="textareaRef"
      />
    </div>

    <template #footer>
      <a-button
        :loading="loading"
        class="primary_medium"
        @click="handleConfirm"
      >
        {{ confirmButtonText }}
      </a-button>
    </template>
  </CustomModal>
</template>

<script setup>
import CustomModal from "@/src/components/CustomModal.vue";
import { computed, ref, watch, nextTick } from "vue";

const props = defineProps({
  source: { type: String, required: true },
  visible: { type: Boolean, required: true },
  title: { type: String, default: "Add Instructions" },
  description: {
    type: String,
    default: "Provide custom instructions the agent should follow.(Optional)",
  },
  placeholder: {
    type: String,
    default: "Enter specific instructions for the research...",
  },
  confirmButtonText: { type: String, default: "Continue" },
  loading: { type: Boolean, default: false },
});

const emits = defineEmits(["update:visible", "confirm"]);

const instructions = ref("");
const textareaRef = ref(null);

const modalVisible = computed({
  get: () => props.visible,
  set: (value) => emits("update:visible", value),
});

const handleConfirm = () => {
  emits("confirm", instructions.value.trim());
};

const handleCancel = () => {
  modalVisible.value = false;
};

// Reset instructions when modal is closed
watch(
  () => props.visible,
  (newVal) => {
    if (!newVal) {
      instructions.value = "";
    } else {
      // Focus textarea when modal opens
      nextTick(() => {
        textareaRef.value?.focus();
      });
    }
  },
  {
    immediate: true,
  }
);
</script>
